import React from 'react';
import styled from 'styled-components';

const D4Style = styled.svg``;

export const D4 = ({ color }) => {
	return (
		<D4Style
			xmlns='http://www.w3.org/2000/svg'
			width='18.729'
			height='22.253'
			viewBox='0 0 18.729 22.253'
		>
			<path
				id='Fish'
				d='M847.362,406.05a22.955,22.955,0,0,0-8.192-3.081v.006a.833.833,0,0,0-.516.061.857.857,0,0,0-.425,1.13,20.472,20.472,0,0,1,1.556,5.64c-.3-.158-.608-.3-.924-.428a13.917,13.917,0,0,0-2.673-.751.852.852,0,0,0-.973,1.2,11.2,11.2,0,0,1,0,8.507h0a.92.92,0,0,0-.072.529.856.856,0,0,0,1,.687,13.83,13.83,0,0,0,2.722-.763c.316-.127.62-.27.924-.425a20.754,20.754,0,0,1-1.525,5.583.852.852,0,0,0,.91,1.249,22.867,22.867,0,0,0,8.192-3.081,17.42,17.42,0,0,0,6.416-7.677.851.851,0,0,0,0-.712,17.447,17.447,0,0,0-6.416-7.677Zm-.93,14.635h0a19.547,19.547,0,0,1-6.033,2.488,26.386,26.386,0,0,0,1.294-6.5.857.857,0,0,0-1.422-.7v0a6.97,6.97,0,0,1-2.054,1.243,9.045,9.045,0,0,1-.886.313,13.663,13.663,0,0,0,0-6.862,8.706,8.706,0,0,1,.886.309,6.993,6.993,0,0,1,2.054,1.243.863.863,0,0,0,1.422-.712,26.4,26.4,0,0,0-1.294-6.5,19.5,19.5,0,0,1,6.033,2.492,15.622,15.622,0,0,1,5.627,6.6,15.651,15.651,0,0,1-5.627,6.6Zm.766-7.885h0a1.815,1.815,0,0,0,1.276,3.1,1.814,1.814,0,1,0,0-3.628,1.792,1.792,0,0,0-1.276.531Zm2.066,1.283h0a.791.791,0,0,1-1.349.556.8.8,0,0,1,0-1.112.8.8,0,0,1,1.119,0,.793.793,0,0,1,.23.556Z'
				transform='translate(-835.128 -402.959)'
				fill={color}
			/>
		</D4Style>
	);
};
